import React from 'react';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { SkipLink, SkipLinkTarget } from '../SkipLink';

export enum IFrameModifier {
  PORTRAIT = 'iframe--portrait',
}

type IFrameProps = {
  title: string;
  src: string;
  modifier?: Modifier<IFrameModifier>;
};

export function IFrame({ title, src, modifier }: IFrameProps) {
  const { t } = useSonTranslation('IFrame');
  const skipLinkId = `skip-iframe-${useHtmlValidId()}`;

  return (
    <>
      <SkipLink id={skipLinkId}>{t('skipLink', { title })}</SkipLink>
      <iframe title={title} src={src} className={extendClassNameWithModifier('iframe', modifier)} loading="lazy" />
      <SkipLinkTarget targetName={t('skipLinkTarget', { title })} id={skipLinkId} />
    </>
  );
}
